import styled from 'styled-components';

export const Container = styled.div`
  width: 50vw;
  height: 100vh;
  overflow-y: scroll;
  box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 2;
`;
